import { GenericObject } from "utility/misc";

export default function redirectToWebhookConnectPage(
  orgStore: GenericObject,
  navigate: Function
): void {
  navigate("/environment/destinations/webhook/connect");
}
